import { render, staticRenderFns } from "./SectorDetails.vue?vue&type=template&id=3e972a68&scoped=true&"
import script from "./SectorDetails.vue?vue&type=script&lang=js&"
export * from "./SectorDetails.vue?vue&type=script&lang=js&"
import style0 from "./SectorDetails.vue?vue&type=style&index=0&id=3e972a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e972a68",
  null
  
)

export default component.exports